<template>
  <div class="ranking-page">
    <h2>Classifica Clienti</h2>

    <div class="filters">
      <label for="fromDate">Dal:</label>
      <input id="fromDate" type="date" v-model="fromDate" @change="() => { page = 1; fetchRanking() }" />
    </div>
    <table>
      <thead>
        <tr>
          <th>Posizione</th>
          <th>Nome</th>
          <th>Lezioni completate</th>
        </tr>
      </thead>
        <tbody>
            <tr v-if="ranking.length === 0">
                <td colspan="3" style="text-align: center; font-style: italic;">
                    Nessun cliente trovato – fromDate: {{ fromDate }} – tot: {{ ranking.length }}
                </td>
            </tr>
            <tr v-else v-for="user in ranking" :key="user.user_id" :class="{ gold: user.position === 1, silver: user.position === 2, bronze: user.position === 3 }">
                <td>
                    <span v-if="user.position === 1">🥇</span>
                    <span v-else-if="user.position === 2">🥈</span>
                    <span v-else-if="user.position === 3">🥉</span>
                    <span v-else>#{{ user.position }}</span>
                </td>
                <td>
                    <router-link :to="{ name: 'admin.user.subscriptions', params: { userid: user.user_id } }">
                    {{ user.name }}
                    </router-link>
                </td>
                <td>{{ user.lessons }}</td>
            </tr>
        </tbody>
    </table>
    <div style="margin-top: 1em; font-style: italic;">
        Totale clienti classificati: {{ total }}
    </div>
    <div class="pagination">
      <button @click="prevPage" :disabled="page === 1">⬅ Indietro</button>
      <span>Pagina {{ page }}</span>
      <button @click="nextPage" :disabled="ranking.length < limit">Avanti ➡</button>
    </div>
  </div>
</template>

<script>
import api from '@/api'

export default {
  name: 'UserRanking',
  data() {
    return {
      ranking: [],
      fromDate: new Date(new Date().getFullYear(), 0, 1).toISOString().substr(0, 10),
      page: 1,
      limit: 20,
      total: 0
    }
  },
  methods: {
    async fetchRanking() {
        console.log(`📅 Chiamo API classifica con from_date = ${this.fromDate}, page = ${this.page}, limit = ${this.limit}`)
        try {
            const res = await api.admin().getRanking({
            from_date: this.fromDate,
            page: this.page,
            limit: this.limit
            })

            console.log('📊 Risposta grezza:', res)

            if (res && res.ranking) {
            console.log('👉 Tipo res.ranking:', typeof res.ranking)
            console.log('👉 Contenuto completo:', res.ranking)
            console.log('👉 Primo elemento:', res.ranking[0])
            console.log('👉 Chiavi del primo elemento:', res.ranking[0] ? Object.keys(res.ranking[0]) : '⚠️ Nessun dato')

            if (Array.isArray(res.ranking)) {
                this.ranking = [...res.ranking]
                this.total = res.total || 0
                console.log('✅ Ranking aggiornato con', this.ranking.length, 'elementi')
            } else {
                console.warn('❌ res.ranking non è un array')
                this.ranking = []
                this.total = 0
            }
            } else {
            console.warn('❌ Risposta senza dati utili')
            this.ranking = []
            this.total = 0
            }
        } catch (err) {
            console.error('❌ Errore caricamento classifica:', err)
            this.ranking = []
            this.total = 0
        }
    },
    nextPage() {
      this.page++
      this.fetchRanking()
    },
    prevPage() {
      if (this.page > 1) {
        this.page--
        this.fetchRanking()
      }
    }
  },
  mounted() {
    setTimeout(() => {
    this.fetchRanking()
  }, 100)
  }
}
</script>

<style scoped>
.ranking-page {
  max-width: 900px;
  margin: auto;
  padding: 20px;
}

.filters {
  margin: 15px 0;
}

.filters label {
  margin-right: 8px;
  font-weight: bold;
  color: #eee;
}

.filters input[type="date"] {
  padding: 4px 8px;
  background-color: #222;
  border: 1px solid #555;
  color: #fff;
  border-radius: 4px;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  background-color: #1e1e1e;
  color: #eee;
  border-radius: 8px;
  overflow: hidden;
}

th, td {
  padding: 10px;
  border-bottom: 1px solid #444;
  text-align: left;
}

th {
  background-color: #2a2a2a;
  color: #ffd700;
  font-weight: bold;
}

tr.gold {
  background-color: rgba(255, 215, 0, 0.15);
}
tr.silver {
  background-color: rgba(192, 192, 192, 0.15);
}
tr.bronze {
  background-color: rgba(205, 127, 50, 0.15);
}

td a {
  color: #ccc; /* colore base */
  text-decoration: none;
}
td a:hover {
  text-decoration: underline;
}
.gold td a {
  color: gold;
}
.silver td a {
  color: silver;
}
.bronze td a {
  color: #cd7f32; /* bronzo */
}

.pagination {
  text-align: center;
  margin-top: 20px;
}

.pagination button {
  padding: 8px 16px;
  font-weight: bold;
  border-radius: 6px;
  border: none;
  background-color: #007bff;
  color: white;
  cursor: pointer;
}

.pagination button:hover {
  background-color: #0056b3;
}

.pagination button:disabled {
  background-color: #555;
  cursor: not-allowed;
}
</style>

